import { store } from '../redux/Store';
import UserSecurity from '../models/UserSecurity';

export default class CurrentUser {
  public static Get(): UserSecurity | null {
    return store.getState().UserSession.Value;
  }
}
